import { render, staticRenderFns } from "./SacConfigQuestion.vue?vue&type=template&id=b90fe67a"
import script from "./SacConfigQuestion.vue?vue&type=script&lang=js"
export * from "./SacConfigQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports